import _ from 'lodash';
const config = require('@/config/vd-settings');
const valid = require('@/util/vd-validate');

const vdui = {
  setSettings(key, value) {
    const keyName = config.storeKey + '-' + key;
    const item = { val: value };
    localStorage.setItem(keyName, JSON.stringify(item));
  },
  getSettings(key) {
    const keyName = config.storeKey + '-' + key;
    const item = localStorage.getItem(keyName) || '{}';
    return JSON.parse(item).val;
  },
  removeSettings(key) {
    const keyName = config.storeKey + '-' + key;
    localStorage.removeItem(keyName);
  },
  setSession(key, value) {
    const keyName = config.storeKey + '-' + key;
    const item = { val: value };
    sessionStorage.setItem(keyName, JSON.stringify(item));
  },
  getSession(key) {
    const keyName = config.storeKey + '-' + key;
    const item = sessionStorage.getItem(keyName) || '{}';
    return JSON.parse(item).val;
  },
  removeSession(key) {
    const keyName = config.storeKey + '-' + key;
    sessionStorage.removeItem(keyName);
  },
  isEmpty(str) {
    return (!_.isNumber(str) && _.isEmpty(str)) || str === 'null' || str === 'undefined';
  },
  isNotEmpty(str) {
    return !vdui.isEmpty(str);
  },
  /**
   * 获取浏览器设备信息
   * @param key
   */
  device(key) {
    let agent = navigator.userAgent.toLowerCase(),
      //获取版本号
      getVersion = function (label) {
        let exp = new RegExp(label + '/([^\\s\\_\\-]+)');
        label = (agent.match(exp) || [])[1];
        return label || false;
      },
      //返回结果集
      result = {
        os: (function () {
          //底层操作系统
          if (/windows/.test(agent)) {
            return 'windows';
          } else if (/linux/.test(agent)) {
            return 'linux';
          } else if (/iphone|ipod|ipad|ios/.test(agent)) {
            return 'ios';
          } else if (/mac/.test(agent)) {
            return 'mac';
          }
        })(),
        ie: (function () {
          //ie版本
          return !!window.ActiveXObject || 'ActiveXObject' in window
            ? (agent.match(/msie\s(\d+)/) || [])[1] || '11' //由于ie11并没有msie的标识
            : false;
        })(),
        weixin: getVersion('micromessenger'), //是否微信
      };

    //任意的key
    if (key && !result[key]) {
      result[key] = getVersion(key);
    }

    //移动设备
    result.android = /android/.test(agent);
    result.ios = result.os === 'ios';

    return result;
  },
  hasToken() {
    return vdui.isNotEmpty(vdui.getSession('token'));
  },
};
const out = _.merge(vdui, valid);

export default out;
